import type { TranslationSchema } from './types'

export const ja: TranslationSchema = {
  Common: {
    reset: 'クリア',
    close: '閉じる',
    back: '戻る'
  },
  Auth: {
    signUp: 'ユーザー登録',
    activation: 'アクティベーション',
    signIn: 'サインイン',
    authChallenge: 'MFA認証',
    signOut: 'サインアウト',
    passwordReset: 'パスワードリセット',
    passwordInitialize: 'パスワード初期化',
    passwordUpdate: 'パスワード更新',
    userId: 'ユーザID',
    userName: '氏名(漢字)',
    emailOrPhone: 'メールアドレスまたは携帯電話番号(SMS通知用)',
    phoneNumber: '携帯電話番号(SMS通知用)',
    email: 'メールアドレス',
    password: 'パスワード',
    reenterPassword: 'もう一度パスワードを入力してください。',
    verificationCode: '検証コード',
    sendVerificationCode: '検証コード送信',
    mfaCode: '検証コード',
    sendMfaCode: '検証コード送信',
    forgotPassword: 'パスワードを忘れた場合',
    sendPasswordResetMail: 'リセットメール送信',
    newPassword: '新しいパスワード',
    reenterNewPassword: 'もう一度新しいパスワードを入力してください。',
    updatePassword: 'パスワード更新',
    currentPassword: '現在のパスワード'
  }
}
